var map = {
	"./Alchimeia.png": "./src/assets/img/progress/islands/Alchimeia.png",
	"./Alchimeia_closed.png": "./src/assets/img/progress/islands/Alchimeia_closed.png",
	"./Fabella.png": "./src/assets/img/progress/islands/Fabella.png",
	"./Fabella_closed.png": "./src/assets/img/progress/islands/Fabella_closed.png",
	"./Lumina.png": "./src/assets/img/progress/islands/Lumina.png",
	"./Lumina_closed.png": "./src/assets/img/progress/islands/Lumina_closed.png",
	"./Morbida.png": "./src/assets/img/progress/islands/Morbida.png",
	"./Morbida_closed.png": "./src/assets/img/progress/islands/Morbida_closed.png",
	"./Oracle.png": "./src/assets/img/progress/islands/Oracle.png",
	"./Oracle_closed.png": "./src/assets/img/progress/islands/Oracle_closed.png",
	"./Sylva.png": "./src/assets/img/progress/islands/Sylva.png",
	"./Sylva_closed.png": "./src/assets/img/progress/islands/Sylva_closed.png",
	"./Temperus.png": "./src/assets/img/progress/islands/Temperus.png",
	"./Temperus_closed.png": "./src/assets/img/progress/islands/Temperus_closed.png",
	"./Veritas.png": "./src/assets/img/progress/islands/Veritas.png",
	"./Veritas_closed.png": "./src/assets/img/progress/islands/Veritas_closed.png",
	"./Void.png": "./src/assets/img/progress/islands/Void.png",
	"./chance.png": "./src/assets/img/progress/islands/chance.png",
	"./chance_closed.png": "./src/assets/img/progress/islands/chance_closed.png",
	"./judgement.png": "./src/assets/img/progress/islands/judgement.png",
	"./judgement_closed.png": "./src/assets/img/progress/islands/judgement_closed.png",
	"./solace.png": "./src/assets/img/progress/islands/solace.png",
	"./solace_closed.png": "./src/assets/img/progress/islands/solace_closed.png"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/assets/img/progress/islands sync recursive ^\\.\\/.*\\.png$";